import React, { useState } from "react"
import { Grid, Typography, Box } from "@mui/material"
import CommonModal from "components/CommonModal"
import AppDatePicker from "components/AppDatePicker"
import AppButton from "components/StyledComponents/AppButton"
import StyledLabel from "components/StyledComponents/StyledLabel"

const GenerateQuizModal = ({ open, onClose, onSubmit, isLoading }) => {
  const [selectedDate, setSelectedDate] = useState(null)

  const handleSubmit = () => {
    const yearValue = selectedDate.getFullYear()
    const monthValue = selectedDate.getMonth() + 1
    onSubmit({ year: yearValue, month: monthValue })
  }

  const handleClose = () => {
    setSelectedDate(null)
    onClose()
  }

  const actionButtons = (
    <Box sx={{ display: "flex", justifyContent: "center", gap: 2, pb: 2 }}>
      <AppButton onClick={handleClose} disabled={isLoading}>
        Cancel
      </AppButton>
      <AppButton onClick={handleSubmit} disabled={isLoading}>
        Generate
      </AppButton>
    </Box>
  )

  return (
    <CommonModal
      open={open}
      onClose={handleClose}
      onSubmit={handleSubmit}
      actionButtons={actionButtons}
      maxWidth="sm">
      <Box sx={{ pt: 2 }}>
        <Typography variant="h2" sx={{ mb: 3, textAlign: "center" }}>
          Generate Weekly Quizzes
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} className="datesContainer">
            <StyledLabel variant="body1Regular">
              {"Select Date"}
              <span>*</span>
            </StyledLabel>
            <Box className="dateFieldContainer w-100 mt-2">
              <AppDatePicker
                minDate={new Date()}
                maxDate={new Date().setMonth(new Date().getMonth() + 5)}
                inputFormat="dd MMM yyyy"
                disableMaskedInput
                key={"selectedDate"}
                value={selectedDate}
                onChange={(val) => setSelectedDate(val)}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </CommonModal>
  )
}

export default GenerateQuizModal
